import { render, staticRenderFns } from "./DetailApproval.vue?vue&type=template&id=33aad678&"
import script from "./DetailApproval.vue?vue&type=script&lang=js&"
export * from "./DetailApproval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports